/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Lorem Ipsum real Latin?`)
};

const es_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es Lorem Ipsum latín real?`)
};

const de_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Lorem Ipsum echtes Latein?`)
};

const nl_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Lorem Ipsum echt Latijn?`)
};

const fr_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le Lorem Ipsum est-il du vrai latin ?`)
};

const it_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum è vero latino?`)
};

const pt_br2_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum é latim real?`)
};

const pt_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum é latim real?`)
};

const ja_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsumは本物のラテン語ですか？`)
};

const zh_li_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum是真正的拉丁文吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_faq2_q", locale)
	if (locale === "en") return en_li_faq2_q(inputs)
	if (locale === "es") return es_li_faq2_q(inputs)
	if (locale === "de") return de_li_faq2_q(inputs)
	if (locale === "nl") return nl_li_faq2_q(inputs)
	if (locale === "fr") return fr_li_faq2_q(inputs)
	if (locale === "it") return it_li_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_li_faq2_q(inputs)
	if (locale === "pt") return pt_li_faq2_q(inputs)
	if (locale === "ja") return ja_li_faq2_q(inputs)
	return zh_li_faq2_q(inputs)
};